import get from 'lodash/get'

import { RootState } from 'store'

export const getUsrId = (state: RootState) => get(state, 'oidc.user.profile.eid', null)
export const getUorIdMst = (state: RootState) => get(state, 'oidc.user.profile.uor', null)
export const getLanId = (state: RootState) => get(state, 'oidc.user.profile.lan', null)
